import {Pipe, PipeTransform} from '@angular/core';
import {Observable} from 'rxjs';
import {MapperService} from '../../services/mapper.service';
import {map} from 'rxjs/operators';

@Pipe({
    name: 'riskName',
    standalone: true
})
export class RiskNamePipe implements PipeTransform {

  constructor(
    private _mapperService: MapperService
  ) {}

  transform(value: string): Observable<string> {
        return this._mapperService.getListOfRiskTypes().pipe(
            map((list) => {
                const risk = list.find(r => r.type_risque === value);
                return risk ? risk.name : value;
            })
        );
    }
}
